export class APIError extends Error {
    constructor(status, data, title = null, message = "") {
        super(data);
        this.name = 'APIError';
        this.status = status;
        this.title = title;
        this.descriptionsArray = data?.detail ? [data.detail] : [];
        this.message = message;
    }

    translate(t) {
        if (!this.title) {
            this.title = t("errors:apiError");
        }
        return this;
    }
}

export class BadRequestError extends APIError {
    constructor(data) {
        super(400, data);
        this.name = 'BadRequestError';
    }

    translate(t) {
        if (!this.title) {
            this.title = t("errors:badRequestError");
        }
        return this;
    }
}

export class UnauthorizedError extends APIError {
    constructor(data) {
        super(401, data);
        this.name = 'UnauthorizedError';
    }

    translate(t) {
        if (!this.title) {
            this.title = t("errors:unauthorizedError");
        }
        return this;
    }
}

export class ForbiddenError extends APIError {
    constructor(data, title, message) {
        super(403, data, title, message);
        this.name = 'ForbiddenError';
    }

    translate(t) {
        if (!this.title) {
            this.title = t("errors:forbiddenError");
        }
        return this;
    }
}

export class NotFoundError extends APIError {
    constructor(data) {
        super(404, data);
        this.name = 'NotFoundError';
    }

    translate(t) {
        if (!this.title) {
            this.title = t("errors:notFoundError");
        }
        return this;
    }
}

export class InternalServerError extends APIError {
    constructor(data) {
        super(500, data);
        this.name = 'InternalServerError';
    }

    translate(t) {
        if (!this.title) {
            this.title = t("errors:internalServerError");
        }
        return this;
    }
}

export class ValidationError extends APIError {
    constructor(data) {
        super(422, data);
        this.name = 'ValidationError';

        // parse the FastApi validation error
        const detail = data?.detail || [];
        if (Array.isArray(detail) && detail.length > 0) {
            this.descriptionsArray = detail.map(d => d.msg || d.message || d);
        } else if (typeof detail === 'string') {
            this.descriptionsArray = [detail];
        } else {
            this.descriptionsArray = [];
        }
        this.message = this.descriptionsArray.join(', ');
    }

    translate(t) {
        if (!this.title) {
            this.title = t("errors:validationError");
        }
        return this;
    }
}

export class UnknownError extends APIError {
    constructor(data) {
        super(0, data);
        this.name = 'UnknownError';
    }

    translate(t) {
        if (!this.title) {
            this.title = t("errors:unknownError");
        }
        return this;
    }
}

export class NetworkError extends APIError {
    constructor(data) {
        super(0, data);
        this.name = 'NetworkError';
    }

    translate(t) {
        if (!this.title) {
            this.title = t("errors:networkError");
        }
        return this;
    }
}